import { render, staticRenderFns } from "./LegalNotice.vue?vue&type=template&id=142be5b0&scoped=true"
import script from "./LegalNotice.vue?vue&type=script&lang=ts"
export * from "./LegalNotice.vue?vue&type=script&lang=ts"
import style0 from "./LegalNotice.vue?vue&type=style&index=0&id=142be5b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142be5b0",
  null
  
)

export default component.exports